import React, { useMemo, useCallback, useRef } from 'react';
import FormDataChangeContext from './FormDataChangeContext';
var FormDataChangeWrapper = function FormDataChangeWrapper(_ref) {
  var onChange = _ref.onChange,
    formData = _ref.formData,
    children = _ref.children,
    schema = _ref.schema;
  var formDataRef = useRef();
  formDataRef.current = formData;
  var putFormData = useCallback(function (options) {
    var formData = formDataRef.current;
    var data = options.data,
      destination = options.destination;
    if (data && destination) {
      var newData = JSON.parse(JSON.stringify(formData));
      if (typeof destination.key !== 'undefined') {
        if (typeof destination.index !== 'undefined') {
          Object.assign(newData[destination.key][destination.index], data);
        } else {
          Object.assign(newData[destination.key], data);
        }
      } else {
        newData = Object.assign({}, newData, data);
      }
      onChange && onChange(newData);
    }
  }, [onChange]);
  var context = useMemo(function () {
    return {
      putFormData: putFormData,
      schema: schema
    };
  }, [schema, putFormData]);
  return /*#__PURE__*/React.createElement(FormDataChangeContext.Provider, {
    value: context
  }, children);
};
export default FormDataChangeWrapper;